/**
 * Hide header on scroll down, show on scroll up (mobile only < 1081px)
 * Removes js__header__stuck 50px before top to prevent glitch
 */
(function () {
  const BREAKPOINT = 1081;
  const GLITCHBREAKPOINT = 460;
  const SCROLL_THRESHOLD = 0;
  const TOP_THRESHOLD_MOBILE = 140;
  const TOP_THRESHOLD_DESKTOP = 200;
  let header = null;
  let lastScrollY = 0;
  let scrolledDown = 0;
  let isHidden = false;

  function getTopThreshold() {
    return window.innerWidth >= GLITCHBREAKPOINT ? TOP_THRESHOLD_DESKTOP : TOP_THRESHOLD_MOBILE;
  }

  function handleScroll() {
    const currentScrollY = window.scrollY;
    const delta = currentScrollY - lastScrollY;
    const topThreshold = getTopThreshold();

    // Near top of page - remove stuck class to prevent glitch (all screens)
    if (currentScrollY <= topThreshold) {
      if (header && header.dataset.lockedByValidation !== 'true') {
        header.classList.remove('header-scroll-hide');
        header.classList.remove('header-scroll-hide-instant');
        isHidden = false;
      }

      scrolledDown = 0;
      lastScrollY = currentScrollY;
      return;
    }

    // Desktop - only handle the stuck class removal above, skip hide/show
    if (window.innerWidth >= BREAKPOINT) {
      lastScrollY = currentScrollY;
      return;
    }

    // Mobile only: hide/show on scroll
    // Scrolling down
    if (delta > 0) {
      scrolledDown += delta;
      // If we just crossed the threshold while scrolling down, hide instantly (no animation)

      if (lastScrollY <= topThreshold && currentScrollY > topThreshold) {
        hideHeaderInstant();
      } else if (scrolledDown >= SCROLL_THRESHOLD) {
        hideHeader();
      }
    }
    // Scrolling up
    else if (delta < 0) {
      scrolledDown = 0;
      showHeader();
    }

    lastScrollY = currentScrollY;
  }

  function hideHeader() {
    if (!isHidden && header) {
      header.classList.remove('header-scroll-hide-instant');
      header.classList.add('header-scroll-hide');
      isHidden = true;
    }
  }

  function hideHeaderInstant() {
    if (header) {
      header.classList.add('header-scroll-hide-instant');
      header.classList.remove('header-scroll-hide');
      isHidden = true;
    }
  }

  function showHeader() {
    if (isHidden && header) {
      // Don't show header if locked by validation scroll
      if (header.dataset.lockedByValidation === 'true') {
        return;
      }
      header.classList.remove('header-scroll-hide');
      header.classList.remove('header-scroll-hide-instant');
      isHidden = false;
    }
    scrolledDown = 0;
  }

  function addStyles() {
    if (document.getElementById('header-scroll-styles')) return;
    const style = document.createElement('style');
    style.id = 'header-scroll-styles';
    style.textContent = [
      '@media (max-width: 1080px) {',
      '  [data-header-sticky].js__header__stuck {',
      '    transition: top 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;',
      '    will-change: transform;',
      '    backface-visibility: hidden;',
      '  }',
      '  [data-header-sticky].js__header__stuck.header-scroll-hide {',
      '    top: calc(-1 * var(--header-height, 80px)) !important;',
      '    pointer-events: none;',
      '  }',
      '  [data-header-sticky].js__header__stuck.header-scroll-hide-instant {',
      '    top: calc(-1 * var(--header-height, 80px)) !important;',
      '    pointer-events: none;',
      '    transition: none !important;',
      '  }',
      '}',
    ].join('\n');
    document.head.appendChild(style);
  }

  function init() {
    header = document.querySelector('[data-header-sticky]');
    if (!header) {
      setTimeout(init, 100);
      return;
    }

    addStyles();
    lastScrollY = window.scrollY;

    let ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      if (window.innerWidth >= BREAKPOINT) {
        showHeader();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
